import { render } from "./ItemSectionComponent.vue?vue&type=template&id=881a987e"
import script from "./ItemSectionComponent.vue?vue&type=script&scoped=true&lang=js"
export * from "./ItemSectionComponent.vue?vue&type=script&scoped=true&lang=js"

import "./ItemSectionComponent.vue?vue&type=style&index=0&id=881a987e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__